(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/embedded-giving/views/partials/eg.views.partials.donation-payment-methods', '<div\n' + '  data-ng-include="::EmbeddedGivingPaths.pay.root"\n' + '  data-ng-controller="EmbeddedGivingDonationCtrl"\n' + '  class="eg-container"\n' + '></div>\n' + '');
}]);
})();